import React from "react";

import ErrorPage from "../Error/ErrorPage";

export const BillingErrorPage = () => {
	return (
		<ErrorPage
			code={422}
			title="Billing Unavailable"
			description="For more information about billing in PerformYard and how you can purchase seats, please contact your account manager or customer success representative."
		/>
	);
};

export default BillingErrorPage;
